export interface SeriesEpisode {
  date: string;
  title: string;
  text: string;
}

export interface Series {
  slug: string;
  title: string;
  category: string;
  heat: string;
  status: "已完结" | "持续跟进";
  period: string;
  tagline: string;
  cover: string;
  summary: string;
  cast: string[];
  episodes: SeriesEpisode[];
  comment: string;
}

export const seriesList: Series[] = [
  {
    slug: "juyue-fengbo",
    title: "顶流解约风波：一份合约引发的连锁反应",
    category: "合约风波",
    heat: "846万",
    status: "持续跟进",
    period: "2026.03 — 至今",
    tagline: "从“和平分手”到“违约诉讼”，解约为何总能撕成一地鸡毛？",
    cover: "https://readdy.ai/api/search-image?query=Pop-art%20editorial%20illustration%20of%20a%20long%20legal%20contract%20scroll%20being%20torn%20in%20half%20by%20two%20cartoon%20hands%2C%20with%20a%20judge%20gavel%2C%20megaphone%20and%20small%20flame%20sparks%20floating%20around%2C%20warm%20coral%20orange%20and%20cream%20palette%2C%20bold%20outlines%2C%20flat%20modern%20vector%20style%2C%20playful%20gossip%20magazine%20cover%20art%2C%20dynamic%20diagonal%20composition%2C%20clean%20warm%20beige%20background&width=900&height=700&seq=series-contract-x1&orientation=landscape",
    summary:
      "当红顶流突然宣布解约，粉丝狂欢与资本错愕同时上演。我们从一份被曝光的合同条款讲起，把“竞业限制”“天价违约金”“资源置换”逐条拆开，串起解约潮背后的行业规则。",
    cast: ["顶流艺人本人", "原经纪公司", "粉丝群体", "资本与片方"],
    episodes: [
      {
        date: "2026.03.12",
        title: "导火索：一场“档期缩水”引发的公开不满",
        text: "顶流因连续三个月行程被削减而发布长文，称“被安排成透明人”。文中虽未点名，但业内普遍指向其经纪团队资源分配失衡。粉丝迅速集结话题，要求公司“给个说法”。",
      },
      {
        date: "2026.03.19",
        title: "正式摊牌：工作室发文宣布“将另行发展”",
        text: "工作室深夜发布声明，宣布艺人将“以个人名义另行发展”，并透露原公司存在“阴阳合同”与“资源截留”疑云。该声明半天内阅读破亿，登上多个热搜。",
      },
      {
        date: "2026.03.27",
        title: "公司反诉：天价违约金条款被曝光",
        text: "原经纪公司随后发函提起违约之诉，要求支付高达数亿元的违约金，并同步晒出合同附件。网友惊呼“违约金够普通人吃十辈子瓜”。双方进入漫长的拉锯。",
      },
      {
        date: "2026.04.02",
        title: "竞业限制争议：能不能接同题材戏",
        text: "争议焦点转向“竞业限制”条款，公司主张三年内不得出演同类题材。法律博主下场科普，指出竞业限制需合理对价。话题从吃瓜升级为普法现场。",
      },
      {
        date: "2026.04.15",
        title: "资本角力：旧东家疑似“撬资源”",
        text: "有媒体曝出顶流尚未开拍的项目被原东家旗下新人接盘，质疑是否存在“恶意占资源”。片方沉默，粉丝再度声援，舆论天平反复摇摆。",
      },
      {
        date: "2026.05.20",
        title: "当前进展：庭前调解窗口开启",
        text: "双方同意就违约金与资源交接进行庭前调解，外界猜测或将以“部分和解”收场。我们持续跟进，后续走向待更新。",
      },
    ],
    comment:
      "解约风波常见的共性是：粉丝先点燃、法务后上场、资本最后收尾。与其站队，不如把三方的说辞放在同一张时间线上看证据与措辞的温差。",
  },
  {
    slug: "taxi-yiye",
    title: "塌房一夜：从顶流到退圈的完整时间线",
    category: "塌房现场",
    heat: "901万",
    status: "已完结",
    period: "2025.11 — 2026.01",
    tagline: "十天之内，一个“完美人设”是怎么崩塌成碎片的。",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20pop%20illustration%20of%20a%20golden%20celebrity%20pedestal%20collapsing%20into%20pieces%20while%20a%20spotlight%20beam%20dims%20above%2C%20silhouette%20figures%20and%20swirls%20falling%2C%20warm%20coral%20red%20orange%20cream%20color%20palette%2C%20bold%20graphic%20outlines%2C%20flat%20modern%20vector%2C%20dramatic%20energetic%20gossip%20poster%2C%20clean%20warm%20beige%20background%2C%20no%20text&width=900&height=700&seq=series-taxi-x1&orientation=landscape",
    summary:
      "从一张偷拍照到最终声明退圈，整个过程不到一个月。我们按天还原事件推进的每个节点，看“塌房”是如何一步步从实锤、冷处理走向不可挽回。",
    cast: ["涉事顶流", "爆料账号", "官方通报方", "广告代言方"],
    episodes: [
      {
        date: "2025.11.08",
        title: "起点：一张模糊的偷拍照",
        text: "某爆料博主放出顶流与友人深夜同行的模糊照片，标题直指“人设崩塌”。起初多数粉丝认为是恶意造谣，话题热度有限。",
      },
      {
        date: "2025.11.11",
        title: "实锤加码：录音与行程单流出",
        text: "次日放出带时间戳的录音与行程单，与艺人此前公开的“工作安排”严重冲突。舆论开始两极分化，“铁粉”与“路人”展开拉锯。",
      },
      {
        date: "2025.11.16",
        title: "代言解约：资本用脚投票",
        text: "多个代言品牌在24小时内先后宣布“合作到期”“暂停合作”，广告方集体用脚投票，成为事件的重要分水岭。",
      },
      {
        date: "2025.11.22",
        title: "冷处理失效：工作室回应被指含糊",
        text: "工作室发布含混声明称“网络信息不实，保留追责权利”，但未正面回应关键实锤，被网友批评“避重就轻”，热度不降反升。",
      },
      {
        date: "2025.12.01",
        title: "官方通报：实锤落地",
        text: "权威通报方就相关行为作出说明，坐实部分爆料内容。此节点后，反转可能性基本归零，商业合作陆续终止。",
      },
      {
        date: "2026.01.05",
        title: "终点：宣布退圈并致歉",
        text: "顶流发布退圈声明并公开致歉，表示“将深刻反省、回归普通生活”。从偷拍到退圈，前后不足两个月。",
      },
    ],
    comment:
      "塌房事件一旦进入“偷拍→实锤→撤代言→通报”的节奏，几乎很少能反转。关键在回应是否正面，态度是否诚恳——拖得越久，裂缝越深。",
  },
  {
    slug: "zongyi-juben",
    title: "综艺“剧本”争议：恶意剪辑罗生门",
    category: "综艺幕后",
    heat: "668万",
    status: "已完结",
    period: "2026.04 — 2026.06",
    tagline: "选手哭戏“满屏不自然”，是演技尴尬还是剧本硬塞？",
    cover: "https://readdy.ai/api/search-image?query=Colorful%20pop%20illustration%20of%20a%20TV%20clapperboard%20and%20film%20reel%20wrapped%20in%20tangled%20red%20tape%20and%20strings%2C%20cameras%20and%20bright%20spotlights%20in%20the%20background%2C%20warm%20orange%20pink%20cream%20palette%2C%20bold%20graphic%20comic%20style%2C%20modern%20flat%20vector%20editorial%20art%2C%20playful%20tabloid%20poster%2C%20clean%20warm%20beige%20background%2C%20no%20text&width=900&height=700&seq=series-zongyi-x1&orientation=landscape",
    summary:
      "一档选秀综艺因选手“哭戏尴尬”出圈，导演组被指按剧本安排情节。我们对比历季剪辑争议，拆解综艺究竟有几分真、几分秀。",
    cast: ["参赛选手", "节目组", "导师团队", "后援会"],
    episodes: [
      {
        date: "2026.04.08",
        title: "名场面：选手表演式大哭被群嘲",
        text: "一期淘汰赛上，多名选手先后上演相似度极高的“崩溃大哭”，连动作和台词都高度雷同。弹幕刷屏“剧本！”，相关片段全网二创疯传。",
      },
      {
        date: "2026.04.14",
        title: "选手开麦：承认“被要求按台本哭”",
        text: "一名被淘汰选手开直播吐槽，称情绪转折“是按导演给的台本演的”，随即引发节目组强烈否认。谁在说谎成为最大看点。",
      },
      {
        date: "2026.04.21",
        title: "镜头考古：历季“剧本痕”被翻出",
        text: "网友考古出本节目过往多季“同款哭戏”“同款反转”，并剪辑成合集对比。恶意剪辑与节目效果之间的边界被广泛讨论。",
      },
      {
        date: "2026.05.02",
        title: "官方下场：节目组声明“保留追责权”",
        text: "节目组发布声明，强调“一切内容基于真实发生”，并称将追究恶意剪辑传播者法律责任。粉丝与路人对声明半信半疑。",
      },
      {
        date: "2026.05.18",
        title: "导师发声：承认综艺有“节目效果”",
        text: "某导师在采访中坦言“综艺难免有节目效果，但底线是不造假”，被解读为侧面承认存在引导。话题再上热搜。",
      },
      {
        date: "2026.06.02",
        title: "尘埃落定：新一季宣布“加直播环节”",
        text: "节目组宣布新一季增设无台本的直播环节，以回应“剧本”质疑。舆论逐渐从争论转向观望，事件热度回落。",
      },
    ],
    comment:
      "“剧本争议”背后是综艺真实性与可看性的天然拉扯。观众要的不是没有剧本，而是别把观众当傻子——剪辑与引导需要一条能被看见的底线。",
  },
  {
    slug: "kaogu-heilishi",
    title: "被考古的“黑历史”：旧帖删不掉的反噬",
    category: "考古回放",
    heat: "721万",
    status: "持续跟进",
    period: "2026.05 — 至今",
    tagline: "越是急着删，越是有人扒。互联网没有真正的“删除键”。",
    cover: "https://readdy.ai/api/search-image?query=Warm%20toned%20pop%20illustration%20of%20an%20old%20photo%20album%20and%20vintage%20film%20camera%20being%20scanned%20by%20a%20large%20magnifying%20glass%20with%20floating%20question%20marks%20and%20small%20sparkles%2C%20cream%20coral%20orange%20palette%2C%20bold%20comic%20outline%20vector%20style%2C%20flat%20editorial%20illustration%2C%20playful%20mystery%20mood%2C%20clean%20warm%20beige%20background%2C%20no%20text&width=900&height=700&seq=series-kaogu-x1&orientation=landscape",
    summary:
      "当红小花因一条多年前的旧评论被考古，删帖反而引出一串“考古接力”。我们从删帖心理学聊到明星互联网资产管理的行业潜规则。",
    cast: ["当红小花", "考古博主", "旧社交平台", "经纪公关团队"],
    episodes: [
      {
        date: "2026.05.06",
        title: "导火索：一条七年前的“逆发言论”",
        text: "考古博主翻出小花七年前在社交平台的旧评论，其中观点引发争议。话题被贴上“人设矛盾”标签迅速扩散。",
      },
      {
        date: "2026.05.09",
        title: "删除反噬：帖子消失引发“考古接力”",
        text: "相关旧帖在数小时内被集中删除，反而刺激大量网友展开“考古接力”，备份、截图纷至沓来，旧照旧帖接连被扒出。",
      },
      {
        date: "2026.05.15",
        title: "团队回应：归因“年少轻狂已道歉”",
        text: "工作室回应称相关言论系早年“年少轻狂”，已在私下向受影响者致歉。公关话术被网友拿来与历次“考古翻车”声明对比。",
      },
      {
        date: "2026.05.24",
        title: "翻车升级：更多同款旧帖被摆上台面",
        text: "新一轮考古挖出更多同款历史发言，内容与“谦逊人设”强烈冲突，公关“轻描淡写”的回应被广泛质疑。",
      },
      {
        date: "2026.06.03",
        title: "行业声音：明星“互联网清史”资产观",
        text: "公关业内人士发声，建议明星正视历史发言、及早自查而非“堵嘴式删除”。事件引发的行业讨论价值逐渐超过八卦本身。",
      },
      {
        date: "2026.06.20",
        title: "当前进展：全面自查与公开整改",
        text: "团队宣布将配合平台对历史账号进行全面自查，并表示将发布更正式的公开说明。事件仍在发酵，我们保持跟进。",
      },
    ],
    comment:
      "互联网的“删除键”从来不是清除，而是放大。越是明星，越要接受发言会被考古的设定。真正的解法不是删，而是诚实面对与持续的自律。",
  },
];